import { useEffect, useState } from 'react';
import {
  getTheme,
  readStoredThemeId,
  type ThemeArt,
  type ThemeId,
} from '../lib/themes';

/** Active art theme (localStorage) for home and studio preview. */
export function useThemeArt(overrideId?: ThemeId | null): ThemeArt {
  const [id, setId] = useState<ThemeId>(() => overrideId ?? readStoredThemeId());

  useEffect(() => {
    if (overrideId) {
      setId(overrideId);
      return;
    }
    setId(readStoredThemeId());
    const onStorage = (e: StorageEvent) => {
      if (e.key === 'missnatalie-art-theme' && e.newValue) {
        setId(readStoredThemeId());
      }
    };
    const onCustom = (e: Event) => {
      const detail = (e as CustomEvent<ThemeId>).detail;
      if (detail) setId(detail);
    };
    window.addEventListener('storage', onStorage);
    window.addEventListener('missnatalie-theme', onCustom);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.removeEventListener('missnatalie-theme', onCustom);
    };
  }, [overrideId]);

  return getTheme(id);
}
